import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import * as classnames from 'classnames';
import { itemIsGroup, } from 'console/sortableDeviceTree/utils/tree-type';
const style = { width: '100%' };
export function nodeContentRenderer(props) {
    const { toggleChildrenVisibility, connectDragPreview, connectDragSource, isDragging, canDrop, canDrag, node, path, treeIndex, didDrop, rowWrapper, RenderItem, RenderGroupItem, selected_device_id, } = props;
    const isLandingPadActive = !didDrop && isDragging;
    const onClickNode = useCallback(() => {
        if ('children' in node && toggleChildrenVisibility)
            toggleChildrenVisibility({ node, path, treeIndex });
    }, [node, toggleChildrenVisibility, path, treeIndex]);
    const Item = useMemo(() => (itemIsGroup(node) ? RenderGroupItem : RenderItem), [node]);
    const nodeContent = connectDragPreview(_jsx("div", { style: style, children: _jsx(Item, { className: classnames('rowContents', {
                rowContentsDragDisabled: !canDrag,
            }), onClick: onClickNode, node: node, path: path, treeIndex: treeIndex, selected_device_id: selected_device_id }) }));
    return (_jsx("div", { className: classnames('rowWrapper', { rowWrapperDragDisabled: !canDrag }), style: { height: rowWrapper }, children: _jsx("div", { className: classnames('row', {
                rowLandingPad: isLandingPadActive,
                rowCancelPad: isLandingPadActive && !canDrop,
            }), children: canDrag
                ? connectDragSource(nodeContent, { dropEffect: 'copy' })
                : nodeContent }) }));
}
